import { useState, useEffect } from 'react';
import AccountAgreeDropDown from './DropDown';
import Icon from 'src/components/Icon';
import { useTranslation } from 'react-i18next';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { TERMS_TYPE } from 'src/constants/agree';
import { getTermList } from 'src/services/api';
import { isKorean } from 'src/services/util';
import dayjs from 'dayjs';

type Props = {
  title: string;
  type: TERMS_TYPE;
  setter: (_: boolean) => void;
};

export default function TermsModal({ title, type, setter }: Props): JSX.Element {
  const history = useCustomHistory();
  const { t } = useTranslation();
  const [listIndex, setListIndex] = useState(0);
  const [data, setData] = useState<TermItem[]>();

  const onClickLogo = (e: any) => {
    e.preventDefault();
    setter(false);
    history.push('/');
  };
  const onClickEvent = (e: any) => {
    e.stopPropagation();
    setter(false);
  };
  useEffect(() => {
    getTermList({
      type,
    }).then((res) => {
      const values = res[Object.keys(res)[0]];
      setData(values);
      window.scrollTo(0, 0);
    });
  }, []);
  return (
    <>
      <div className="fixed w-full h-full top-0 left-0 bg-white" style={{ zIndex: 60 }} />
      <div className="absolute top-0 left-0 w-full h-full bg-white" style={{ zIndex: 61 }}>
        <div className="relative flex w-full justify-center items-center h-13 container z-50 top-0 left-0 text-black">
          <div className="absolute left-5"></div>
          <a href="#" onClick={onClickLogo}>
            <Icon name="logo_s" size="90" sizeH="22" />
          </a>
          <div className="absolute right-5">
            <button onClick={onClickEvent} className="block">
              <Icon name="close" size="32" />
            </button>
          </div>
        </div>
        <div className="container bg-white">
          <h1 className="N_20_R pt-6">{title}</h1>
          <div className="mt-4 flex items-center justify-start">
            <div className="N_12_R text-brown-grey mr-3">{t('account/agree/terms_date')}</div>
            {data && (
              <AccountAgreeDropDown value={listIndex} setValue={(index) => setListIndex(+index)}>
                {data.map(({ enforcementDate }, index) => {
                  return (
                    <option key={index} value={index}>
                      {dayjs(enforcementDate).format('YYYY-MM-DD')}
                    </option>
                  );
                })}
              </AccountAgreeDropDown>
            )}
          </div>
          {data && (
            <div
              className="py-7 bg-white terms-text"
              dangerouslySetInnerHTML={{ __html: data[listIndex][isKorean() ? 'koContent' : 'enContent'] }}
            />
          )}
        </div>
      </div>
    </>
  );
}
